import React, { useState } from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import EditAddressForm from './EditAddressForm';

function EditAddressModal({
  accountId,
  onAddressUpdated,
  buttonOpenModal,
  account,
  address
}) {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpenModal = () => {
    setIsOpen(true);
  };

  const handleCloseModal = () => {
    setIsOpen(false);
  };

  const handleAddressUpdated = () => {
    onAddressUpdated();
    setIsOpen(false);
  };

  return (
    <>
      {buttonOpenModal && buttonOpenModal({ onClick: handleOpenModal })}

      <Modal isOpen={isOpen} toggle={handleCloseModal} size="lg">
        <ModalHeader toggle={handleCloseModal}>Editar Endereço</ModalHeader>
        <ModalBody>
          <EditAddressForm
            accountId={accountId}
            onAddressUpdated={handleAddressUpdated}
            onCancel={handleCloseModal}
            account={account}
            address={address}
          />
        </ModalBody>
      </Modal>
    </>
  );
}

export default EditAddressModal;
